import { ProgramacaoColetaAnalise } from "@/contexts/laboratorio/programacaoColeta/model/ProgramacaoColetaAnalise";
import { api } from "@/shared/api/api";

export const createProgramacaoColetaApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<ProgramacaoColetaAnalise[]>(
      "/programacoes-coleta-analise/todas",
      { headers }
    );
    return data;
  };

  return { listAll };
};
